import { SVGProps } from 'react';
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15 6 6-3v15l-6 3V6ZM9 18l6 3V6L9 3v15ZM3 6l6-3v15l-6 3V6Z"
    />
  </svg>
);
export default SvgMap;
